// Centralizes every window.parent.postMessage call the widget makes,
// so the message "protocol" with the host page lives in one file.

const postToParent = (message) => window.parent.postMessage(message, "*");

export const notifyContentReady = () => postToParent({ type: "contentReady" });
export const notifyIsMobile = () => postToParent({ type: "isMobile" });
export const notifyUpdateIdsOk = () => postToParent({ type: "updateIdsOk" });
export const notifyIncomingMessage = (count) =>
  postToParent({ type: "incomingMessage", value: count });

export const hideWidget = () => postToParent("hide");
export const showWidget = () => postToParent("show");
export const enterFullScreenWidget = () => postToParent("enterFullScreen");
export const exitFullScreenWidget = () => postToParent("exitFullScreen");
